import React from 'react';
import Header from './Header';
import NavigationMenu from './NavigationMenu';
import Series from './Series';
import '../assests/styles/Home.scss';

const Home = () => {
    return (
        <div className="home-page">
            <div className="content-wrapper">
                <Header />
                <NavigationMenu />
            </div>

            {/* Neon line divider */}
            <div className="neon-line"></div>
            <Series />
        </div>
    );
};

export default Home;
